<template>
  <div>
    <v-layout
        :id="'post-assessment-selection-' + contentItem.name"
        class="flex items-start gap-3 p-4 rounded-lg border treatment-row-container cursor-pointer"
        @click="handleSelect"
    >
      <div>
        <div v-for="(item, index) in contentItem.detailContent"
             :key="item+'_'+index"
        >
          <mrx-translation
              class="assessment-light" :class="(contentItem.headerToken) ? 'treatment-text' : 'treatment-header'"
              :token="item"
          ></mrx-translation>
        </div>
      </div>
    </v-layout>
    <v-divider
        v-if="!isLast"
        class="me-3"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import MrxTranslation from "@/components/thinkmd/mrx/translation.vue";
import type { DisabledItemsMap, FollowUpContentItem } from "@/features/overall-assessment/types/overall-assessment.types";

export default defineComponent({
  name: "CarePlanRow",
  components: { MrxTranslation },
  props: {
    contentItem: { type: Object as PropType<FollowUpContentItem>, required: true },
    isChecklist: { type: Boolean, default: false },
    isLast: { type: Boolean, default: false },
    disabledItems: { type: Object as PropType<DisabledItemsMap>, default: () => ({}) },
    checkboxIcon: { type: String, default: "" }
  },
  methods: {
    handleSelect() {
      this.$emit("select", this.contentItem.name);
    }
  }
});
</script>
